module.exports = __webpack_public_path__ + "img/liushui (9).a62686ed.png";